import React, { useState, useEffect } from 'react';
import { Container, Paper, TextField, Button, Typography, Box, Alert, CircularProgress } from '@mui/material';
import api from '../services/api';
import logoImage from '../images/Thermowool logo login.png';

interface LoginProps {
  onLogin?: () => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Prikaži loading screen kada se stranica učita na login-u
  useEffect(() => {
    if (!localStorage.getItem('token')) {
      sessionStorage.setItem('shouldShowLoading', 'true');
    }
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      // Koristi isti API klijent kao ostatak aplikacije,
      // koji pokazuje na lokalni backend (http://localhost:3001/api)
      const res = await api.post('/users/login', { username, password });
      
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      
      // Postavi flag za prikazivanje loading screen-a
      sessionStorage.setItem('shouldShowLoading', 'true');
      
      if (onLogin) onLogin();
      else window.location.href = '/';
    } catch (e: any) {
      setError(e?.response?.data?.error || 'Greška pri logovanju');
    } finally {
      setLoading(false);
    }
  };

  // Ako je već ulogovan, ne prikazuj login
  if (localStorage.getItem('token')) return null;

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
        <Box sx={{ mb: 3 }}>
          <img 
            src={logoImage} 
            alt="Thermowool Logo" 
            style={{ 
              maxWidth: '200px', 
              height: 'auto',
              marginBottom: '16px'
            }} 
          />
          <Typography variant="h4" component="h1" gutterBottom>
            Prijava
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Sistem za tehnička merenja proizvoda
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ 
            display: 'block',
            p: 1,
            backgroundColor: 'rgba(25, 118, 210, 0.1)',
            borderRadius: 1,
            border: '1px solid rgba(25, 118, 210, 0.2)'
          }}>
            🔐 Poboljšana sigurnost: Access token važi 15 minuta, automatski refresh
          </Typography>
        </Box>
        
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Korisničko ime"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            margin="normal"
            required
            autoFocus
            disabled={loading}
          />
          <TextField
            fullWidth
            label="Lozinka"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            margin="normal"
            required
            disabled={loading}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : 'Prijavi se'}
            </Button>
        </form>
        
        <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
          Ograničeno na 5 pokušaja prijave u 15 minuta
        </Typography>
      </Paper>
    </Container>
  );
};

export default Login; 